<div mat-dialog-title class="modal-header header-radius-4 py-0">
    <div class="mx-3 d-flex justify-content-between align-items-center">
        <div>
            <h4>Cancellation Reason</h4>
        </div>
        <div>
            <button mat-dialog-close class="close close-btn" title="Close" type="button">
                <i class="fa fa-close"></i>
            </button>
        </div>
    </div>
</div>

<mat-dialog-content>
    <ng-container *ngIf="loader">
        <div class="row my-4">
            <div class="d-flex justify-content-center">
                <div class="dot-pulse mX-25-50"></div>
            </div>
        </div>
    </ng-container>
    <div *ngIf="!loader" class="cancellation-reason">
        <div class="member-card">
            <div class="row">
                <div class="col-md-6">
                    <div class="cancellation-type">
                        <strong>Cancellation Type:</strong>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div id="cancellationType">
                        {{ reasonDetails?.cancellationType ? reasonDetails?.cancellationType : 'NA' }}
                    </div>
                </div>
            </div>
            <div *ngIf="reasonDetails?.serviceRequestState" class="row">
                <div class="col-md-6">
                    <div class="cancellation-type">
                        <strong>Cancellation Step:</strong>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div id="serviceRequestState">
                        {{ reasonDetails?.serviceRequestState }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="cancellation-type">
                        <strong>Cancellation Reason:</strong>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div id="cancellationReason">
                        {{ reasonDetails?.cancellationReason ? reasonDetails?.cancellationReason : 'NA' }}
                    </div>
                </div>
            </div>
            <div *ngIf="reasonDetails?.additionalDescription" class="row">
                <div class="col-md-6">
                    <div class="cancellation-type">
                        <strong>More info:</strong>
                    </div>
                </div>
                <div class="col-md-6 form-group">
                    <div id="additionalDescription">
                        {{ reasonDetails?.additionalDescription }}
                    </div>
                </div>
            </div>
            <div *ngIf="reasonDetails?.cancelledVendors?.length" class="row">
                <div class="col-md-12">
                    <div class="cancellation-type">
                        <strong>Cancelled Vendors:</strong>
                    </div>
                </div>
                <div class="col-md-12">
                    <div *ngFor="let vendor of reasonDetails?.cancelledVendors" class="row cancellation-vendors">
                        <div class="col-md-4">{{ vendor?.vendorName }}</div>
                        <div class="col-md-4">{{ vendor.isCancellationFeePresent ? 'Yes' : 'No' }}</div>
                        <div class="col-md-4">$ {{ vendor.cancellationCost }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
